module.exports = __webpack_public_path__ + "static/media/5.12_preview.42dc7959.png";